/**
 * Created by Ning Jiang on 3/15/2017.
 */

import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {TeslaServerDataParser} from "../TeslaServerDataParser";

export class TeslaParsedInitData extends ParsedInitData {
    private _wildsCollected:[number];

    public get wildsCollected():number[] {
        return this._wildsCollected;
    }

    constructor(rawData:any, dataParser:TeslaServerDataParser) {
        super(rawData, dataParser);

        this._wildsCollected = dataParser.parseWildsCollected(rawData);
    }
}